import Phaser from 'phaser';
import conversationData from '../scripts/Conversations.js';
import * as fontConfig from '../scripts/FontConfig.js';

export default class ReflectionScene extends Phaser.Scene {
  constructor() {
    super('ReflectionScene');
  }

  init(data) {
    this.friendName = data.friendName || 'Unknown Friend';
    this.success = data.success || false;
    this.doorData = data.doorData || null;
    this.gameData = data.gameData || null;
    
    console.log('ReflectionScene - Friend:', this.friendName, 'Success:', this.success);
    console.log('ReflectionScene - GameData:', this.gameData);
    
    console.log('Raw conversation data:', conversationData);
    
    // Access the conversations array correctly
    const conversations = conversationData.conversations || conversationData;
    console.log('Conversations array:', conversations);
    
    // Find the conversation data for this friend
    console.log('Looking for friend:', `"${this.friendName}"`);
    
    this.conversation = conversations.find(conv => {
      console.log(`Comparing "${conv.name}" with "${this.friendName}"`);
      return conv.name === this.friendName;
    });
    
    console.log('Conversation lookup result:', this.conversation);
    
    if (!this.conversation) {
      console.error('No conversation found for friend:', this.friendName);
      console.log('Available friends:', conversations.map(c => c.name));
      this.reflection = [];
    } else if (!this.conversation.reflection) {
      console.error('No reflection data in conversation for:', this.friendName);
      console.log('Conversation structure:', Object.keys(this.conversation));
      this.reflection = [];
    } else {
      this.reflection = this.conversation.reflection;
      console.log('Successfully loaded reflection data:', this.reflection);
    }
    
    // Initialize reflection tracking
    this.currentStatementIndex = 0;
    this.reflectionData = [];
    this.statementStartTime = 0;
    this.timerActive = false;
    
    // Initialize game data structure if not provided
    if (!this.gameData) {
      this.gameData = {
        friend: this.friendName,
        startTime: Date.now(),
        answers: [],
        reflections: []
      };
    }
    
    // Ensure reflections array exists
    if (!this.gameData.reflections) {
      this.gameData.reflections = [];
    }
  }

  create() {
    console.log('ReflectionScene create() called');
    console.log('Reflection data available:', this.reflection.length, 'statements');

    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background
    // this.add.rectangle(width / 2, height / 2, width, height, 0x2c3e50);
    this.add.image(width / 2, height / 2, 'backgroundScreen').setOrigin(0.5);
   
    
    // Load and setup the reflection tilemap
    this.setupTilemap();
    
    // Create UI elements based on tilemap placeholders
    this.createTilemapBasedUI();
    
    // Add fade-in transition
    this.cameras.main.fadeIn(300, 0, 0, 0);
    
    // Setup keyboard controls
    this.setupKeyboardControls();
    
    // Start with first statement
    if (this.reflection.length === 0) {
      console.error('No reflection statements available');
      this.proceedToVillage();
      return;
    }
    
    this.showStatement();
  }

  setupTilemap() {
    // Create the tilemap from the JSON
    this.map = this.make.tilemap({ key: 'reflection' });
    
    // Add the tileset to the tilemap
    const uiTileset = this.map.addTilesetImage('ui', 'ui');
    // const speechbubbles = this.map.addTilesetImage('speechbubbles', 'speechbubbles');
    
    // Render background layers
    const backgroundBg = this.map.createLayer('Background-bg', uiTileset);
    const background = this.map.createLayer('Background', uiTileset);
    const backgroundFg = this.map.createLayer('Background-fg', uiTileset);
    backgroundFg.setDepth(24);
    const base = this.map.createLayer('Base', [uiTileset]);
    base.setDepth(25);
    
    // Extract placeholder positions from object layers
    this.extractPlaceholders();
  }
  
  extractPlaceholders() {
    // Store placeholder positions
    this.placeholders = {};
    
    // Get the object layer containing UI placeholders
    const objectLayer = this.map.getObjectLayer('placeholders');
    
    if (objectLayer) {
      objectLayer.objects.forEach(obj => {
        // Store placeholder positions
        this.placeholders[obj.name] = {
          x: obj.x,
          y: obj.y,
          width: obj.width,
          height: obj.height
        };
      });
    }
    
    console.log('Extracted reflection placeholders:', this.placeholders);
  }
  
  createTilemapBasedUI() {
    // Initialize UI properties to prevent undefined errors
    this.ratingButtons = [];
    this.nextButton = null;
    this.nextButtonText = null;
    this.timerText = null;
    this.rewardLabel = null;
    this.statementEnumText = null;
    this.statementText = null;
    this.friendPortrait = null;
    this.notApplicableButton = null;
    this.notApplicableButtonText = null;
    
    // Create UI elements positioned using tilemap placeholders
    this.createLabels();
    this.createFriendPortrait();
    this.createRatingButtons();
    this.createNextButton();
  }

  createLabels() {
    // Timer/Read well label
    if (this.placeholders.LblReadWell) {
      const pos = this.placeholders.LblReadWell;
      this.timerText = fontConfig.createText(
        this, 
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        'Lees de stelling goed... 5 sec', 
        'small', {
          fill: '#3c3939ff',
          align: 'center'
        }
      );
      this.timerText.setOrigin(0.5, 0.5); // Center both horizontally and vertically
      this.timerText.setDepth(30);
    }
    
    // Remove high end and low end labels as they're now covered by scale text
    
    // Reward label
    if (this.placeholders.LblReward) {
      const pos = this.placeholders.LblReward;
      this.rewardLabel = fontConfig.createText(
        this, 
        pos.x + 10, 
        pos.y + 10, 
        'Beantwoord de stellingen \n en verdien 2 bits!', 
        'small', {
          fill: '#ffffff',
          align: 'left'
        }
      );
      this.rewardLabel.setOrigin(0, 0);
      this.rewardLabel.setDepth(30);
    }
    

    // Statement enumeration
    if (this.placeholders.statementEnum) {
      const pos = this.placeholders.statementEnum;
      this.statementEnumText = fontConfig.createText(
        this, 
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        'Stelling 1/4', 
        'small', {
          fill: 'rgba(213, 105, 240, 1)',
          align: 'center'
        }
      );
      this.statementEnumText.setOrigin(0.5, 0.5); // Center both horizontally and vertically
      this.statementEnumText.setDepth(30);
    }
    
    // Statement text - look for common placeholder names
    const statementPlaceholderNames = ['statement'];
    
    for (const placeholderName of statementPlaceholderNames) {
      if (this.placeholders[placeholderName]) {
        const pos = this.placeholders[placeholderName];
        this.statementText = fontConfig.createText(
          this, 
          pos.x + pos.width/2, 
          pos.y + pos.height/2, 
          '', // Will be set when showing statement
          'systemStatement', {
            wordWrap: { width: pos.width - 20 },
            align: 'center'
          }
        );
        this.statementText.setOrigin(0.5, 0.5); // Center both horizontally and vertically
        this.statementText.setDepth(30);
        console.log(`Created statement text with placeholder: ${placeholderName}`);
        break; // Use the first match found
      }
    }
  }

  createFriendPortrait() {
    // Friend portrait in happy state
    if (this.placeholders.placeholderFriend) {
      const pos = this.placeholders.placeholderFriend;
      
      // Create friend portrait in happy state
      this.friendPortrait = this.add.image(
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        `${this.friendName}-happy`
      );
      
      // Scale from 320x320 to fit in 96x96 placeholder
      this.friendPortrait.setScale(pos.width / 320);
      this.friendPortrait.setDepth(32); // Above other UI elements
      
      console.log(`Created friend portrait for ${this.friendName} at (${pos.x + pos.width/2}, ${pos.y + pos.height/2})`);
    } else {
      console.warn('placeholderFriend not found in tilemap placeholders');
    }
  }

  createRatingButtons() {
    // Create the 5 rating buttons as interactive squares
    this.ratingButtons = [];
    this.selectedValue = null;
    
    for (let i = 0; i < 5; i++) {
      const buttonKey = `buttonRate${i + 1}`;
      
      if (this.placeholders[buttonKey]) {
        const pos = this.placeholders[buttonKey];
        
        // Create interactive rectangle
        const button = this.add.rectangle(
          pos.x + pos.width/2, 
          pos.y + pos.height/2, 
          pos.width, 
          pos.height,
          0x111111 // Default gray color
        );
        button.setStrokeStyle(2, 0x2c3e50);
        button.setInteractive({ useHandCursor: true });
        button.setDepth(34);
        button.ratingValue = i; // Store 0-4 index for scale array
        
        // Add rating text - will be set when showing statement
        const buttonText = fontConfig.createText(
          this, 
          pos.x + pos.width/2, 
          pos.y + pos.height/2, 
          '', // Will be filled with scale text
          'systemButton', {
            fontSize: '16px',
            fill: '#ffffff',
            align: 'center',
            wordWrap: { width: pos.width - 10 }
          }
        );
        buttonText.setOrigin(0.5);
        buttonText.setDepth(35);
        
        // Add hover effects
        button.on('pointerover', () => {
          if (!button.selected) {
            button.setFillStyle(0x3498db);
          }
        });
        
        button.on('pointerout', () => {
          if (!button.selected) {
            button.setFillStyle(0x95a5a6);
          }
        });
        
        button.on('pointerdown', () => {
          this.selectRating(button);
        });
        
        button.buttonText = buttonText;
        this.ratingButtons.push(button);
      }
    }
    
    // Create "Niet van toepassing" button
    this.createNotApplicableButton();
  }

  createNotApplicableButton() {
    // Create the "Niet van toepassing" button
    if (this.placeholders.buttonNotApplicable) {
      const pos = this.placeholders.buttonNotApplicable;
      
      // Create interactive rectangle with gray color to match other buttons
      this.notApplicableButton = this.add.rectangle(
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        pos.width, 
        pos.height,
        0x7f8c8d // Medium gray color
      );
      this.notApplicableButton.setStrokeStyle(2, 0x95a5a6);
      this.notApplicableButton.setInteractive({ useHandCursor: true });
      this.notApplicableButton.setDepth(34);
      this.notApplicableButton.ratingValue = 'not_applicable';
      
      // Add button text
      this.notApplicableButtonText = fontConfig.createText(
        this, 
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        '🤷 Niet van toepassing', 
        'systemButton', {
          fontSize: '16px',
          fill: '#ffffff',
          align: 'center'
        }
      );
      this.notApplicableButtonText.setOrigin(0.5);
      this.notApplicableButtonText.setDepth(35);
      
      // Add hover effects with gray shades
      this.notApplicableButton.on('pointerover', () => {
        if (!this.notApplicableButton.selected) {
          this.notApplicableButton.setFillStyle(0x95a5a6); // Light gray on hover
        }
      });
      
      this.notApplicableButton.on('pointerout', () => {
        if (!this.notApplicableButton.selected) {
          this.notApplicableButton.setFillStyle(0x7f8c8d); // Back to medium gray
        }
      });
      
      this.notApplicableButton.on('pointerdown', () => {
        this.selectNotApplicable();
      });
    }
  }

  createNextButton() {
    if (this.placeholders.buttonNext) {
      const pos = this.placeholders.buttonNext;
      
      this.nextButton = this.add.rectangle(
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        pos.width, 
        pos.height,
        0x27ae60
      );
      this.nextButton.setStrokeStyle(2, 0x2ecc71);
      this.nextButton.setInteractive({ useHandCursor: true });
      this.nextButton.setDepth(34);
      this.nextButton.setVisible(false); // Initially hidden
      
      this.nextButtonText = fontConfig.createText(
        this, 
        pos.x + pos.width/2, 
        pos.y + pos.height/2, 
        'Volgende', 
        'default', {
          fill: '#ffffff',
          align: 'center'
        }
      );
      this.nextButtonText.setOrigin(0.5);
      this.nextButtonText.setDepth(35);
      this.nextButtonText.setVisible(false);
      
      // Add hover effects
      this.nextButton.on('pointerover', () => {
        this.nextButton.setFillStyle(0x2ecc71);
      });
      
      this.nextButton.on('pointerout', () => {
        this.nextButton.setFillStyle(0x27ae60);
      });
      
      this.nextButton.on('pointerdown', () => {
        this.nextStatement();
      });
    }
  }
  
  setupKeyboardControls() {
    // Initialize keyboard selection state
    this.keyboardSelectedIndex = 0; // 0-4 for rating buttons, 5 for "niet van toepassing"
    this.keyboardMode = false; // Track if we're using keyboard
    
    // Create cursor keys
    this.cursors = this.input.keyboard.createCursorKeys();
    
    // Add enter key
    this.enterKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.ENTER);
    
    // Listen for key presses
    this.input.keyboard.on('keydown', (event) => {
      // Only handle keyboard input if we're showing a statement
      if (this.currentStatementIndex >= this.reflection.length) {
        return;
      }
      
      this.keyboardMode = true;
      
      switch (event.code) {
        case 'ArrowLeft':
          event.preventDefault();
          this.moveKeyboardSelection(-1);
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.moveKeyboardSelection(1);
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.setKeyboardSelection(5); // "Niet van toepassing"
          break;
        case 'ArrowDown':
          event.preventDefault();
          this.setKeyboardSelection(2); // Middle rating button
          break;
        case 'Enter':
          event.preventDefault();
          this.confirmKeyboardSelection();
          break;
      }
    });
  }
  
  moveKeyboardSelection(direction) {
    // Only move within rating buttons (0-4)
    if (this.keyboardSelectedIndex < 5) {
      this.keyboardSelectedIndex = Math.max(0, Math.min(4, this.keyboardSelectedIndex + direction));
    }
    this.updateKeyboardVisualFeedback();
  }
  
  setKeyboardSelection(index) {
    this.keyboardSelectedIndex = index;
    this.updateKeyboardVisualFeedback();
  }
  
  updateKeyboardVisualFeedback() {
    if (!this.keyboardMode) return;
    
    // Clear all keyboard highlights
    this.ratingButtons.forEach((button, index) => {
      if (!button.selected) {
        if (index === this.keyboardSelectedIndex) {
          // Highlight keyboard selected button
          button.setStrokeStyle(4, 0xffffff);
        } else {
          // Reset to normal stroke
          button.setStrokeStyle(2, 0x2c3e50);
        }
      }
    });
    
    // Handle "niet van toepassing" button
    if (this.notApplicableButton && !this.notApplicableButton.selected) {
      if (this.keyboardSelectedIndex === 5) {
        // Highlight keyboard selected
        this.notApplicableButton.setStrokeStyle(4, 0xffffff);
      } else {
        // Reset to normal stroke
        this.notApplicableButton.setStrokeStyle(2, 0x95a5a6);
      }
    }
  }
  
  confirmKeyboardSelection() {
    // If next button is visible, proceed to next statement
    if (this.nextButton && this.nextButton.visible) {
      this.nextStatement();
      return;
    }
    
    // Otherwise, make selection
    if (this.keyboardSelectedIndex < 5) {
      // Select rating button
      const selectedButton = this.ratingButtons[this.keyboardSelectedIndex];
      if (selectedButton) {
        this.selectRating(selectedButton);
      }
    } else if (this.keyboardSelectedIndex === 5) {
      // Select "niet van toepassing"
      this.selectNotApplicable();
    }
    
    // Disable keyboard mode after selection
    this.keyboardMode = false;
  }
  

  
  selectRating(selectedButton) {
    // Clear previous selection from rating buttons
    this.ratingButtons.forEach(button => {
      button.selected = false;
      button.setFillStyle(0x95a5a6);
      // Reset stroke to normal
      button.setStrokeStyle(2, 0x2c3e50);
    });
    
    // Clear not applicable button selection
    if (this.notApplicableButton) {
      this.notApplicableButton.selected = false;
      this.notApplicableButton.setFillStyle(0x7f8c8d); // Reset to medium gray
      // Reset stroke to normal
      this.notApplicableButton.setStrokeStyle(2, 0x95a5a6);
    }
    
    // Mark new selection
    selectedButton.selected = true;
    selectedButton.setFillStyle(0x2ecc71);
    // Keep normal stroke for selected button
    selectedButton.setStrokeStyle(2, 0x2c3e50);
    
    this.selectedValue = selectedButton.ratingValue;
    
    // Disable keyboard mode after mouse selection
    this.keyboardMode = false;
    
    // Check if 5 seconds have passed and enable button if so
    const elapsed = Date.now() - this.statementStartTime;
    if (elapsed >= 5000) {
      this.enableNextButton();
    }
    
    console.log('Rating selected:', this.selectedValue);
  }
  
  selectNotApplicable() {
    // Clear previous selection from rating buttons
    this.ratingButtons.forEach(button => {
      button.selected = false;
      button.setFillStyle(0x95a5a6);
      // Reset stroke to normal
      button.setStrokeStyle(2, 0x2c3e50);
    });
    
    // Mark not applicable button as selected
    if (this.notApplicableButton) {
      this.notApplicableButton.selected = true;
      this.notApplicableButton.setFillStyle(0x34495e); // Dark gray when selected
      // Reset stroke to normal
      this.notApplicableButton.setStrokeStyle(2, 0x95a5a6);
    }
    
    this.selectedValue = 'not_applicable';
    
    // Disable keyboard mode after mouse selection
    this.keyboardMode = false;
    
    // Check if 5 seconds have passed and enable button if so
    const elapsed = Date.now() - this.statementStartTime;
    if (elapsed >= 5000) {
      this.enableNextButton();
    }
    
    console.log('Not applicable selected');
  }
  
  showStatement() {
    console.log('showStatement called. Index:', this.currentStatementIndex, 'Total:', this.reflection.length);
    
    if (this.currentStatementIndex >= this.reflection.length) {
      console.log('All statements completed');
      this.completeReflections();
      return;
    }
    
    const statement = this.reflection[this.currentStatementIndex];
    console.log('Showing statement:', statement);
    
    // Update progress enumeration
    if (this.statementEnumText) {
      this.statementEnumText.setText(`Stelling ${this.currentStatementIndex + 1}/${this.reflection.length}`);
    }
    
    // Display the actual statement text
    if (this.statementText && statement.statement) {
      // Now that emojis are working, just update the existing text
      this.statementText.setText(statement.statement);
      console.log('Statement text set to:', statement.statement);
    } else {
      console.warn('Statement text element or statement.statement not found');
      console.log('this.statementText:', this.statementText);
      console.log('statement.statement:', statement.statement);
    }
    
    // Update rating buttons with scale text and add line breaks after emojis
    if (this.ratingButtons && statement.scale && Array.isArray(statement.scale)) {
      this.ratingButtons.forEach((button, index) => {
        if (index < statement.scale.length && button.buttonText) {
          let scaleText = statement.scale[index];
          // Add line break after emoji if present (handles numbered emojis and face emojis)
          // scaleText = scaleText.replace(/([0️⃣1️⃣2️⃣3️⃣4️⃣😄🙂😐😕☹️])\s*/, '$1\n');
          
          // Just update the existing text now that emojis are rendering properly
          button.buttonText.setText(scaleText);
        }
      });
    }
    
    // Reset rating selection
    this.ratingButtons.forEach(button => {
      button.selected = false;
      button.setFillStyle(0x95a5a6);
    });
    
    // Reset not applicable button selection
    if (this.notApplicableButton) {
      this.notApplicableButton.selected = false;
      this.notApplicableButton.setFillStyle(0x7f8c8d); // Reset to medium gray
    }
    
    this.selectedValue = null;
    this.minimumTimeElapsed = false;
    
    // Reset keyboard selection
    this.keyboardSelectedIndex = 0;
    this.keyboardMode = false;
    
    // Safely hide next button if it exists
    if (this.nextButton) {
      this.nextButton.setVisible(false);
    }
    if (this.nextButtonText) {
      this.nextButtonText.setVisible(false);
    }
    
    // Start 5-second timer
    this.startStatementTimer();
  }
  
  startStatementTimer() {
    this.statementStartTime = Date.now();
    this.timerActive = true;
    this.timeRemaining = 3000; // 3 seconds in milliseconds
    this.minimumTimeElapsed = false;
    
    // Create timer event
    this.timerEvent = this.time.addEvent({
      delay: 100, // Update every 100ms for smooth countdown
      callback: this.updateTimer,
      callbackScope: this,
      loop: true
    });
  }
  
  updateTimer() {
    if (!this.timerActive) {
      return;
    }
    
    const elapsed = Date.now() - this.statementStartTime;
    this.timeRemaining = Math.max(0, 5000 - elapsed);
    
    const secondsLeft = Math.ceil(this.timeRemaining / 1000);
    
    if (this.timeRemaining > 0) {
      if (this.timerText) {
        this.timerText.setText(`Lees de stelling goed...\n ${secondsLeft} sec`);
      }
    } else {
      // 5 seconds have elapsed
      this.minimumTimeElapsed = true;
      this.timerActive = false;
      this.timerEvent.remove();
      
      // Check if user has selected an answer
      if (this.selectedValue !== null) {
        this.enableNextButton();
      } else {
        if (this.timerText) {
          this.timerText.setText('Kies een antwoord\nom door te gaan');
        }
      }
    }
  }
  
  enableNextButton() {
    // Record the reflection response when enabling the button
    const responseTime = Date.now() - this.statementStartTime;
    
    // Record the reflection response
    const reflectionResponse = {
      statement: this.currentStatementIndex + 1,
      ranking: this.selectedValue,
      timing: responseTime
    };
    
    this.gameData.reflections.push(reflectionResponse);
    
    console.log('Recorded reflection:', reflectionResponse);
    
    // Show next button safely
    if (this.nextButton) {
      this.nextButton.setVisible(true);
    }
    if (this.nextButtonText) {
      this.nextButtonText.setVisible(true);
    }
    
    // Update timer text safely
    if (this.timerText) {
      this.timerText.setText(`Antwoord geselecteerd: ${this.selectedValue + 1}/5`);
    }
  }
  
  nextStatement() {
    this.currentStatementIndex++;
    this.showStatement();
  }
  
  completeReflections() {
    console.log('All reflections complete!');
    console.log('Final game data:', this.gameData);
    
    // Submit complete data to session manager
    this.submitCompleteData();
    
    // Hide UI elements safely
    if (this.timerText) this.timerText.setVisible(false);
    if (this.statementEnumText) this.statementEnumText.setVisible(false);
    if (this.statementText) this.statementText.setVisible(false);
    if (this.friendPortrait) this.friendPortrait.setVisible(false);
    if (this.ratingButtons) {
      this.ratingButtons.forEach(button => {
        if (button) button.setVisible(false);
        if (button && button.buttonText) button.buttonText.setVisible(false);
      });
    }
    if (this.notApplicableButton) this.notApplicableButton.setVisible(false);
    if (this.notApplicableButtonText) this.notApplicableButtonText.setVisible(false);
    if (this.nextButton) this.nextButton.setVisible(false);
    if (this.nextButtonText) this.nextButtonText.setVisible(false);
    
    // Proceed directly to village scene
    this.proceedToVillage();
  }
  
  async submitCompleteData() {
    // Add completion metadata to game data
    this.gameData.completedAt = Date.now();
    this.gameData.success = this.success;
    this.gameData.totalReflectionTime = Date.now() - this.gameData.startTime;
    
    if (window.sessionManager) {
      try {
        // Store the complete game data with reflections using SessionManager
        await window.sessionManager.storeGameData(this.gameData, 'reflectionScene');
        console.log('✅ ReflectionScene complete data stored successfully');
        
        // Also submit as a reflection challenge for analytics
        const reflectionChallengeData = {
          friendName: this.friendName,
          reflections: this.gameData.reflections,
          totalTime: this.gameData.totalReflectionTime,
          success: this.success,
          completeGameData: this.gameData
        };
        
        // Submit reflection challenge (if you want to track it separately)
        await window.sessionManager.submitReflectionChallenge(reflectionChallengeData); // Challenge 6 for reflections
        
      } catch (error) {
        console.error('❌ Error storing reflection data:', error);
      }
    } else {
      console.warn('⚠️ SessionManager not available, falling back to local storage');
      // Fallback to local storage only
      try {
        const existingData = JSON.parse(localStorage.getItem('hypnobreaker_research_data') || '[]');
        existingData.push({
          ...this.gameData,
          sceneType: 'reflectionScene',
          storedAt: Date.now()
        });
        localStorage.setItem('hypnobreaker_research_data', JSON.stringify(existingData));
        console.log('💾 Reflection data stored locally as fallback');
      } catch (error) {
        console.error('❌ Error storing reflection data locally:', error);
      }
    }
  }

  proceedToVillage() {
    console.log('Proceeding to village scene');
    
    // Use Phaser's native camera fade out
    this.cameras.main.fadeOut(500, 0, 0, 0);
    
    // Listen for fade out complete event
    this.cameras.main.once(
      Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE,
      () => {
        // Return to village scene
        this.scene.start('VillageScene', { 
          fromFriend: true,
          fromReflection: true,  // Flag to indicate completion of reflection
          friendName: this.friendName,
          success: this.success
        });
      }
    );
  }
}